import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

export default function TopBar() {
  const { t } = useLanguage();
  const emergencyPhone = t.topBar?.emergencyPhoneRaw || '+38641606346';
  const emergencyPrefix = t.topBar?.emergencyPrefix || t.topBar?.emergencyLine || '';
  const emergencyDisplay = t.topBar?.emergencyPhoneDisplay || '+386 41 606 346';

  return (
    <div className="top-bar">
      <div className="top-bar-content">
        {emergencyPrefix}{' '}
        <a href={`tel:${emergencyPhone}`}>{emergencyDisplay}</a>
      </div>
    </div>
  );
}
